import { call, put, takeLatest } from 'redux-saga/effects';

import * as tiktokActions from './tiktokActions.js';
import { updateTikTokApiCall } from './tiktokAPI.js';

function* updateTikTokSaga({ payload }) {
  try {
    const { data } = yield call(updateTikTokApiCall, payload);
    yield put(tiktokActions.tiktokUpdateStore(data));
  } catch (error) {
    yield put(tiktokActions.tiktokUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* tiktokWatcher() {
  yield takeLatest(tiktokActions.tiktokUpdateRequest.type, updateTikTokSaga);
}
